import TourV2AllInclusionsModal from 'components/OfferPage/TourV2/TourVariations/TourV2AllInclusionsModal'
import ModalContext from 'contexts/ModalContext'
import { useCallback, useContext, useMemo } from 'react'
import { useIntl } from 'react-intl'
import SearchTileStackInclusionsList from '../shared/SearchTileStackInclusionsList'
import Group from 'components/utils/Group'
import useOfferUrl from 'hooks/Offers/useOfferUrl'
import { getIsLuxPlusToursEnabled } from 'checkout/selectors/tourV2Selectors'
import { connect } from 'react-redux'
import LoyaltyInclusions from 'loyalty/components/LoyaltyInclusions'
import useLoyaltyBenefitInclusions from 'loyalty/hooks/useLoyaltyBenefitInclusions'

interface MappedStateProps {
  isLuxPlusEnabled: boolean
}

interface Props extends MappedStateProps {
  offer: App.Tours.TourV2Offer | App.Tours.TourV2OfferSummary
  variation: App.Tours.TourV2OfferVariation
  filters?: App.OfferListFilters
}

function TourV2SearchTileFeatures({ offer, variation, filters, isLuxPlusEnabled }: Props) {
  const intl = useIntl()
  const offerUrl = useOfferUrl(offer, {
    filters,
    offerLinkIncludesFilters: true,
  })

  const viewOfferLabel = intl.formatMessage({
    id: 'an9fxS6JrT5bx3DSTHeR',
    defaultMessage: 'View offer',
  })

  const showModal = useContext(ModalContext)
  const onViewAll = useCallback(() => {
    showModal(<TourV2AllInclusionsModal
      variation={variation}
      primaryActionText={viewOfferLabel}
      primaryActionTo={offerUrl}
    />)
  }, [offerUrl, showModal, variation, viewOfferLabel])

  const memoizedInclusionItems = useMemo(() => {
    if (isLuxPlusEnabled) {
      return variation.inclusionItems
    }
    return variation.inclusionItems.filter(inclusion => !inclusion.isLuxPlusBonus)
  }, [variation.inclusionItems, isLuxPlusEnabled])

  const loyaltyCount = useLoyaltyBenefitInclusions(undefined, variation).length
  const showLoyaltyInline = (memoizedInclusionItems.length + loyaltyCount) <= 3

  if (!memoizedInclusionItems.length && !loyaltyCount) {
    return null
  }

  return (
    <Group direction="vertical" gap={4}>
      <SearchTileStackInclusionsList
        inclusions={memoizedInclusionItems}
        isHighlighted={false}
        truncateAfter={3}
        lineClamp={2}
        onShowMoreClick={onViewAll}
        additionalHiddenCount={showLoyaltyInline ? 0 : loyaltyCount}
      />
      {showLoyaltyInline && <LoyaltyInclusions variation={variation} variant="search-tile" />}
    </Group>
  )
}

export default connect<MappedStateProps, {}, {}, App.State>((state) => {
  return {
    isLuxPlusEnabled: getIsLuxPlusToursEnabled(state),
  }
})(TourV2SearchTileFeatures)
